import { DateFormatEnum } from "requests";

export const DATE_FORMATS = [
  { label: "MM/DD/YYYY", value: DateFormatEnum.MmDdYyyyWithSlash },
  { label: "MONTH DD, YYYY", value: DateFormatEnum.MmDdYyyyWithSpace },
  { label: "DD/MM/YYYY", value: DateFormatEnum.DdMmYyyyWithSlash }
];
